const env = (typeof process !== "undefined" && process.env) || {};

const ensureProcess = () => {
  const root = typeof window !== "undefined" ? window : {};
  if (typeof root.process === "undefined") {
    root.process = { env: {} };
  } else if (!root.process.env) {
    root.process.env = {};
  }
  return root.process.env;
};

const processEnv = ensureProcess();

const runtimeOrigin = typeof window !== "undefined" ? window.location.origin || "" : "";
const apiBase = env.REACT_APP_API_BASE_URL || runtimeOrigin;
processEnv.REACT_APP_API_BASE_URL = processEnv.REACT_APP_API_BASE_URL || apiBase;
processEnv.REACT_APP_ASSET_BASE_URL = processEnv.REACT_APP_ASSET_BASE_URL || apiBase;
processEnv.REACT_APP_GOOGLE_MAPS_KEY = processEnv.REACT_APP_GOOGLE_MAPS_KEY || "";
processEnv.REACT_APP_STRIPE_PUBLISHABLE_KEY =
  processEnv.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
processEnv.REACT_APP_PAYMENTS_MODE =
  processEnv.REACT_APP_PAYMENTS_MODE || "demo";
processEnv.REACT_APP_ENABLE_STRIPE_CARD =
  processEnv.REACT_APP_ENABLE_STRIPE_CARD || "false";
processEnv.PUBLIC_URL = processEnv.PUBLIC_URL || "";
processEnv.NODE_ENV = processEnv.NODE_ENV || "development";


